import { authDomain } from '@auth';
import { useMutation } from '@tanstack/react-query';

export const useRestorePasswordByEmail = () => {
  return useMutation((payload: authDomain.RestorePasswordDto) => {
    return authDomain.authService.restorePasswordByEmail(payload);
  });
};
